import GlobalSnapshot from './GlobalSnapshot';

export default GlobalSnapshot;
